import React from 'react';
import { FormikValues } from 'formik';
import { ActionDatePicker, ActionRadio, ActionResult } from '~/components/Patient/Gap/Actions';
import { getTrimmedName } from '~/util';

export interface FocDetailRowProps {
    detail: MeasureDetailType;
    action: FocActionType;
    submissionAnswer?: SubmissionAnswerType;
    checkboxId: string;
    needsName: boolean;
    readOnly: boolean;
    formik: FormikValues;
}

export function FocDetailRow({
    detail,
    action,
    submissionAnswer,
    checkboxId,
    needsName,
    readOnly,
    formik,
}: FocDetailRowProps) {
    function getDetailInputName(det: MeasureDetailType) {
        return `foc_gap_action_detail_${action.id}_${det.id}_${det.system_id}_answer`;
    }

    return (
        <tr>
            {needsName && <td>{getTrimmedName(detail.name)}</td>}
            <td aria-label="Date Selector">
                <ActionDatePicker
                    name={`foc_gap_action_detail_${action.id}_${detail.id}_${detail.system_id}_date`}
                    detail={detail}
                    checkboxId={checkboxId}
                    inputName={getDetailInputName(detail)}
                    submissionAnswer={submissionAnswer}
                    readOnly={readOnly}
                    formik={formik}
                />
            </td>
            <td>
                {detail.lookup_metadata?.length ? (
                    <ActionRadio
                        detail={detail}
                        gapCollection={action.foc_action_details}
                        getName={getDetailInputName}
                        readOnly={readOnly}
                        checkboxId={checkboxId}
                        formik={formik}
                    />
                ) : (
                    <ActionResult
                        detail={detail}
                        gapCollection={action.foc_action_details}
                        getName={getDetailInputName}
                        readOnly={readOnly}
                        checkboxId={checkboxId}
                        formik={formik}
                    />
                )}
            </td>
        </tr>
    );
}
